var map = {
	"./01.svg": 83367,
	"./02.svg": 7767,
	"./03.svg": 68000,
	"./04.svg": 68303,
	"./05.svg": 99486,
	"./06.svg": 96556,
	"./08.svg": 34994,
	"./09.svg": 29668,
	"./10.svg": 39521,
	"./11.svg": 43148,
	"./12.svg": 33539,
	"./13.svg": 15190,
	"./14.svg": 249,
	"./15.svg": 71677,
	"./16.svg": 63296,
	"./17.svg": 10878,
	"./18.svg": 84372,
	"./19.svg": 40102,
	"./20.svg": 71100,
	"./21.svg": 15141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38553;